




















































































import Vue from 'vue';
import UserRegisterRequestViewModel from '../../../services/v1/viewModel/resource/UserRegisterRequestViewModel';

export default Vue.extend({
  auth: false,
  layout: ['layout-exterior', '_exterior'],
  data: () => ({
    mounted: false,
    user: new UserRegisterRequestViewModel(),
    isLoading: false,
    requestError: undefined,
  }),
  mounted() {
    this.mounted = true;
    this.loadQRData();
  },
  methods:
    {
      tabToNextInput() {
        const inputs = document.getElementsByTagName('input');
        for (let i = 0; i < inputs.length; i += 1) {
          const input = inputs[i];
          if (document!.activeElement!.id === input.id && i + 1 < inputs.length) {
            const nextInput = inputs[i + 1] as HTMLInputElement;
            nextInput.focus();
            break;
          }
        }
      },
      loadQRData() {
        const query = this.$router.currentRoute?.query ?? {};
        const { username, email, registrationKey } = query as Record<string, string>;
        this.user.userName = username;
        this.user.email = email;
        this.user.registrationKey = registrationKey;
      },
      gotoLogin() {
        Vue.$router.push({ path: '/_exterior/login', query: this.$route.query });
      },
      gotoVerifyUser() {
        Vue.$router.push({ path: '/_exterior/verify-user', query: this.$route.query });
      },
      doRegister() {
        if (!this.user.validate()) {
          return;
        }
        this.isLoading = true;
        this.$service.api.core.users.register(this.user)
          .then(() => {
            this.isLoading = false;
            this.gotoVerifyUser();
          })
          .catch((error: any) => {
            this.isLoading = false;
            this.requestError = error;
          });
      },
    },
});

